import {PatronCategoryColor, PatronCategoryColorConversions} from '@aviary/store/common/patron.types';
import {isDefined, isPositiveNumber} from '@aviary/store/common/typing.helpers';

export function calculatePatronCategoryColorFor(chipColor: string, categoryId: number): PatronCategoryColor {
  const patronCategoryColor: PatronCategoryColor | undefined = PatronCategoryColorConversions.get(chipColor);
  if (isDefined(patronCategoryColor)) return patronCategoryColor;
  if (!isPositiveNumber(categoryId)) return 'patron-category-default';

  return `patron-category-${((categoryId - 1) % 5) + 1}` as PatronCategoryColor;
}
